<div class="header">{{ header }}</div>
<div
  class="lx-body"
  [style.color]="color">
  <ng-container *ngIf="!ignoreValue">
    <ng-container *ngIf="value !== null && value !== undefined && value !== ''; else na">
      <span
        *ngIf="(header === 'Operating State' || header === 'Battery Health') && color"
        class="operating-state-dot"
        [style.background-color]="color"></span>
      {{ value }}
    </ng-container>
    <ng-template #na>N/A</ng-template>
  </ng-container>
  <ng-content></ng-content>
</div>
